import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingService } from '../../services/reporting/reporting.service';
import {
  CdsListItem,
  CdsMultiSelectModule,
  CdsLoadingOverlayModule,
  CdsLabelModule,
  AlertDisplay,
  AlertType,
  AlertLevel,
  CdsAlertModule,
  CdsPaginatorModule,
  CdsDataGridModule,
} from '@cds/angular';
import { FormsModule, ReactiveFormsModule, FormControl, FormBuilder } from '@angular/forms';
import { SearchService } from '../../services/search/search.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'app-select-program',
    imports: [
        CommonModule,
        CdsMultiSelectModule,
        CdsLoadingOverlayModule,
        CdsLabelModule,
        CdsAlertModule,
        FormsModule,
        ReactiveFormsModule,
        CdsPaginatorModule,
        CdsDataGridModule,
    ],
    templateUrl: './select-program.component.html',
    styleUrls: ['./select-program.component.scss']
})
export class SelectProgramComponent implements OnInit, AfterViewInit {
  options: CdsListItem[] = [];
  formControl: FormControl = new FormControl({});
  programs: any;
  initialSelectedPrograms: any = [];
  subscriptions: Subscription[] = [];

  display = AlertDisplay.Inline;
  type = AlertType.Secondary;
  level = AlertLevel.Warning;
  hasSelectedProgram: boolean;

  reportDescription: string = '';
  selectedRows: any = null;
  @Output() selected = new EventEmitter<string>();
  @Output() isLoadingPrograms = new EventEmitter<boolean>();

  constructor(public searchService: SearchService,
              public reportingService: ReportingService,
              public formBuilder: FormBuilder,
              private changeDetectorRef: ChangeDetectorRef) {
    this.hasSelectedProgram = this.searchService.currentSelectedAccount && this.searchService.selectedPrograms[this.searchService.currentSelectedAccount.key]?.length > 0 ? true : false;
  }

  ngOnInit(): void {
    this.getPrograms();
  }

  ngAfterViewInit() {
    this.reportDescription = this.reportingService.getReportDescription('selectProgram');
  }

  getPrograms() {
    this.isLoadingPrograms.emit(true);
    const selectedAccountName = this.searchService.currentSelectedAccount?.key;
    const query = this.searchService.getProgramsQuery(selectedAccountName);
    const searchSub = this.searchService.searchClaims(query).subscribe((programs: any) => {
      this.programs = programs?.Search?.aggregations?.clients?.buckets;
      this.isLoadingPrograms.emit(false);
      this.selectedRows = [];
      this.programs.forEach((program: any) => {
        if (this.hasSelectedProgram) {
          if (this.searchService.selectedPrograms[this.searchService.currentSelectedAccount.key].includes(program.key)) {
            this.initialSelectedPrograms.push(program.key)
            this.selectedRows.push(program.key)
          }
        } else if (!this.searchService.selectedPrograms[this.searchService.currentSelectedAccount.key]) {
          this.initialSelectedPrograms.push(program.key)
          this.selectedRows.push(program.key)
        }
      });
      this.searchService.currentSelectedPrograms[this.searchService.currentSelectedAccount.key] = this.selectedRows;

      this.transformCoverageTypes();
      this.transformProgramNumbers();
      this.formControl = this.buildFilterFormControl(this.programs);
      this.options = this.buildFilterOptions(this.programs);
      this.changeDetectorRef.detectChanges();
    });
    this.subscriptions.push(searchSub);
  }

  private transformCoverageTypes() {
    this.programs.forEach((program: any) => {
      program.coverage_types_list = program.coverage_types.buckets.map((type: any) => {
        return type.key === 'GC' ? 'GL' : (type.key === 'VA' ? 'AL' : type.key)
      })
        .join(', ');
      return program;
    });
  }

  private transformProgramNumbers() {
    this.programs.forEach((program: any) => {
      program.program_code_list = program.program_code.buckets.map((type: any) => {
        return type.key
      })
        .join(', ');
      return program;
    });
  }

  getReadout() {
    const statusOptions = Object.values(this.formControl.value['All programs']);
    const selectedOptionCounts = statusOptions.filter((val) => val === true).length;
    if (selectedOptionCounts == statusOptions.length) {
      return `All Programs Selected`;
    } else {
      if (selectedOptionCounts > 1) {
        return `(${selectedOptionCounts}) Programs Selected`;
      } else {
        return '';
      }
    }
  }

  onSelect(event: any) {
    this.selected.emit(event);
    this.selectedRows = Object.values(event).map((program: any) => {
      return program.key ;
    });
    this.searchService.currentSelectedPrograms[this.searchService.currentSelectedAccount.key] = this.selectedRows;
  }

  private buildFilterOptions(programs: []): CdsListItem[] {
    const children = Object.values(programs).map((program: any) => {
      return { key: program.key, label: program.key };
    });

    return  [
      {
        key: 'All programs',
        label: 'All programs',
        children: [
          ...children
        ]
      }
    ];
  }

  private buildFilterFormControl(programs: []): FormControl {
    let optionGroupFormControl: any = {};
    Object.values(programs).map((program: any) => {
      const key = program.key;
      optionGroupFormControl[key] = this.searchService.selectedPrograms[this.searchService.currentSelectedAccount.key]?.includes(key);
    });
    const control = new FormControl({
      'All programs': optionGroupFormControl
    });
    return control;
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
